export const clientRoutes = [
  'CLIENT_OVERVIEW',
  'CLIENT_PORTFOLIO',
  'CLIENT_DOCUMENTS',
  'CLIENT_UPLOADER',
  'CLIENT_PROFILE_SETTINGS'
]

export const prospectRoutes = [
  'CLIENT_DOCUMENTS',
  'CLIENT_UPLOADER',
  'CLIENT_PROFILE_SETTINGS',
]

export const prospectPayloadsAllowed = {
  CLIENT_PROFILE_SETTINGS: {
    profileType: ['login']
  }
}

const isPayloadAllowed = (allowedPayloads, payload) => (
  Object.keys(allowedPayloads).every(currentElement => (
    allowedPayloads[currentElement].includes(payload[currentElement])
  ))
)

export const isOnlineExperienceClientRoute = route => clientRoutes.includes(route)
export const isOnlineExperienceProspectRoute = (route, payload) => {
  const isRouteFound = prospectRoutes.includes(route)
  if (!isRouteFound) return false
  const allowedRoutePayloades = prospectPayloadsAllowed[route] || []

  return !!isPayloadAllowed(allowedRoutePayloades, payload)
}

export default {
  clientRoutes,
  prospectRoutes,
  isOnlineExperienceClientRoute,
  isOnlineExperienceProspectRoute,
}



// WEBPACK FOOTER //
// ./src/routing/routes/onlineExperienceRoutes.js